import { requestService } from '../services';
import { requestConst } from '../consts';
import { processFailure } from './utils';

export const categoriesActions = {
    getAll
};

function getAll() {
    return dispatch => {
        dispatch(request());

        requestService.getCategories().then(
            categories => {
                dispatch(success(categories));
            },
            error => onError(error, dispatch)
        );
    };

    function request() {
        return { type: requestConst.CATEGORIES_REQUEST };
    }
    function success(categories) {
        return { type: requestConst.CATEGORIES_SUCCESS, categories };
    }
    function onError(error, dispatch) {
        processFailure({
            dispatch,
            error,
            action: {
                type: requestConst.CATEGORIES_FAILURE
            }
        });
    }
}
